export default {
  setInitialState(
    state,
    { firstDate, lastDate, engagementId, engagementTypeId, isSummary }
  ) {
    state.firstDate = firstDate;
    state.lastDate = lastDate;
    state.engagementId = engagementId;
    state.engagementTypeId = engagementTypeId;
    state.isSummary = isSummary;
  },
  setEngagement(state, { engagement }) {
    state.engagement = engagement;
  },
  setAttributions(state, { attributions }) {
    state.attributions = attributions;
  },
  setTimezone(state, { timezone }) {
    state.timezone = timezone;
  },
  setIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },
};
